import React from 'react';
import ParentingEnglish from '../../src/components/Parenting/ParentingEnglish';
import ParentingDifferentLanguage from '../../src/components/ParentingHindiBangla/ParentingHindi';
import {
  getDifferentLanguageParentingData,
  getParentingDataEnglish,
} from '../../src/Utils/i18Utils/Parenting';

export async function getServerSideProps(context) {
  const locale = context.locale;
  if (locale === 'en') {
    return getParentingDataEnglish(context);
  }
  return getDifferentLanguageParentingData(context, locale);
}

export default function ParentingPage(props) {
  switch (props.language) {
    case 'en':
      return <ParentingEnglish {...props} />;
    default:
      return <ParentingDifferentLanguage {...props} />;
  }
}
